import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Formik } from "formik";
import { Text } from "./styles";
import PostForm from "../components/PostForm";
import { initialValues, schema } from "../../../../constants/forms/post/edit";
import Submit from "../../../../components/FormikForm/Submit";
import Link from "../../../../components/Link";
import Grid from "../../../../components/Grid";
import Snackbar from "../../../../components/Snackbar";
import Loader from "../../../../components/LogoLoader";
import {
  editPost,
  resetEditPost,
  getPost,
} from "../../../../store/actions/post";
import { CategoryDto } from "../../../../types/category";
import { Post } from "../../../../types/post";
import { Group } from "../../../../types";
import { useLayout } from "../../../../providers/LayoutProvider";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { getGroupById } from "../../../../store/actions/group";
import { hideModal, showModal } from "../../../../store/actions/modal";
import { setToZeroTimeZone } from "../../../../helpers/dates-hanlder";
import { ConnectedFocusError } from "../../../../components/ConnectedFocusError";
import { useFileUploadProgress } from "../../../../providers/FileUploader";
import ModalWaitAMinuteBis from "../New/components/ModalWaitAMinute";

interface ComponentProps {
  match;
  userInformation;
  allCategoriesInformation;
  allCategoriesInformationStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  groupInformation: Group;
  groupInformationStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  postInformation: Post;
  postInformationStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  editPostStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

const Component = ({
  match,
  userInformation,
  groupInformation,
  postInformation,
  postInformationStates,
  editPostStates,
}: ComponentProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const { layout, setLayout } = useLayout();

  const { uploadFiles, resetFileUploadProgress } = useFileUploadProgress();
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const timestamp = new Date().getTime();

  const onSubmit = async ({ values, actions }) => {
    //Cuando migremos cover_pic podremos descomentar la linea de abajo
    //Debemos sumar la siguiente validacion "values.cover_pic?.some(file => file instanceof File"
    const thereAreFilesToUpload = values && values.attached_files?.some(file => file instanceof File);

    if (thereAreFilesToUpload) {
      dispatch(showModal("modal-wait-a-minute-bis"));
    }

    try {
      if (thereAreFilesToUpload) {
        const uploadedFiles = await uploadFiles(
          {
            //Cuando migremos cover_pic podremos descomentar la linea de abajo
            //...(values?.cover_pic && values?.cover_pic.length > 0 && { cover_pic: values?.cover_pic }),
            ...(values?.attached_files && values?.attached_files.length > 0 && { attached_files: values?.attached_files }),
          },
          userInformation.id,
          "post"
        );

        const updatedValues = {
          ...values,
          schedule_publish_at: values.schedule_publish_at ? setToZeroTimeZone(values.schedule_publish_at) : null,
          notificate_by_email: values.notificate_by_email.includes("true"),
          notificate_by_telegram: values.notificate_by_telegram.includes("true"),
          show_scheduled_post: values.show_scheduled_post.includes("true"),
          block_files_download: values.block_files_download.includes("true"),
          pinned: values.pinned.includes("true"),
          is_free: values.is_free.includes("true"),
          ask_for_phone: values.ask_for_phone.includes("true"),
          attached_files: uploadedFiles?.attached_files ? uploadedFiles?.attached_files : []
        };

        dispatch(editPost(updatedValues));
      } else {
        // If there are no files to upload, dispatch newWelcomeContentPost directly
        const updatedValues = {
          ...values,
          schedule_publish_at: values.schedule_publish_at ? setToZeroTimeZone(values.schedule_publish_at) : null,
          notificate_by_email: values.notificate_by_email.includes("true"),
          notificate_by_telegram: values.notificate_by_telegram.includes("true"),
          show_scheduled_post: values.show_scheduled_post.includes("true"),
          block_files_download: values.block_files_download.includes("true"),
          pinned: values.pinned.includes("true"),
          is_free: values.is_free.includes("true"),
          ask_for_phone: values.ask_for_phone.includes("true"),
          attached_files: values?.attached_files
        };

        dispatch(editPost(updatedValues));
      }
    } catch (error) {
      console.error('Error during file uploads:', error);
    } finally {
      dispatch(hideModal());
    }
  };

  useEffect(() => {
    if (!!postInformation && editPostStates.success) {
      setTimeout(() => {
        const groupId = groupInformation?.id
        const postId = postInformation?.id
        dispatch(resetEditPost());
        resetFileUploadProgress();
        dispatch(hideModal());
        history.push(`/group/${groupId}/p/${postId}`);
      }, 3500);
    }
  }, [postInformation, editPostStates]);

  useEffect(() => {
    if (
      !!match.params &&
      (!groupInformation ||
        (!!groupInformation &&
          groupInformation.id !== Number(match.params.idGroup)))
    ) {
      dispatch(getGroupById({ group_id: match.params.idGroup }));
    }

    if (
      !!match.params &&
      (!postInformation ||
        (!!postInformation &&
          postInformation.id !== Number(match.params.idPost)))
    ) {
      dispatch(getPost({ idPost: match.params.idPost }));
    }
  }, [match]);

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title: "Editar Lead Magnet",
        description: "Editar Lead Magnet",
      },
      dashboard: {
        tabs: {
          visible: false,
        },
      },
      header: {
        visible: true,
        actions: [
          <Link
            options={{
              type: "outline",
              size: "lg",
              skin: "purple",
              native: true,
            }}
            disabled={!groupInformation}
            href={`/dashboard/community/${groupInformation?.id}/lead-magnets/`}
          >
            Cancelar
          </Link>,
          <Submit
            isSubmmiting={editPostStates.loading}
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
            }}
            disabled={!groupInformation}
            form="edit-post-form"
          >
            Guardar Lead Magnet
          </Submit>,
        ],
      },
    });
  }, [groupInformation, postInformation, editPostStates]);

  if (!postInformation || postInformationStates.loading) {
    return <Loader />;
  }

  return (
    <>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col md={7}>
            <Formik
              initialValues={{
                ...initialValues,
                ...postInformation,
                notificate_by_email: postInformation.notificate_by_email ? ["true"] : [],
                notificate_by_telegram: postInformation.notificate_by_telegram ? ["true"] : [],
                block_files_download: postInformation.block_files_download ? ["true"] : [],
                pinned: postInformation.pinned ? ["true"] : [],
                show_scheduled_post: postInformation.show_scheduled_post ? ["true"] : [],
                is_free: postInformation.is_free ? ["true"] : [],
                ask_for_phone: postInformation.ask_for_phone ? ["true"] : [],
                content_categories: postInformation.content_categories?.map(
                  (item: CategoryDto) => item.id
                ),
                group: postInformation?.group?.id,
                cover_pic: postInformation?.cover_pic ? [postInformation?.cover_pic] : [],
              }}
              onSubmit={(values, actions) => {
                if (onSubmit) onSubmit({ values, actions });
              }}
              validateOnChange={false}
              validateOnBlur={formSubmmited}
              validationSchema={schema}
              enableReinitialize
            >
              {({ handleSubmit, ...rest }) => {
                return (
                  <form
                    className="theme-form"
                    onSubmit={(event) => {
                      setFormSubmmited(true);
                      handleSubmit(event);
                    }}
                    id="edit-post-form"
                  >
                    <ConnectedFocusError />
                    <PostForm {...rest} />
                  </form>
                );
              }}
            </Formik>
          </Grid.Col>
        </Grid.Row>

        {!isMobile && (
          <Grid.Row>
            <Grid.Col>
              <Link
                style={{ marginRight: "8px" }}
                options={{
                  type: "outline",
                  size: "lg",
                  skin: "purple",
                  native: true,
                }}
                href={`/dashboard/community/${groupInformation?.id}/lead-magnets/`}
              >
                Cancelar
              </Link>

              <Submit
                isSubmmiting={editPostStates.loading}
                options={{
                  type: "filled",
                  size: "lg",
                  skin: "purple",
                }}
                form="edit-post-form"
              >
                Guardar Lead Magnet
              </Submit>
            </Grid.Col>
          </Grid.Row>
        )}
      </Grid.Container>

      <ModalWaitAMinuteBis />

      <Snackbar
        visible={editPostStates.success || !!editPostStates.error}
        options={{
          time: 2000,
          type: editPostStates.success ? "success" : "error",
        }}
      >
        {editPostStates.success
          ? "Lead Magnet editado."
          : "Error al editar el Lead Magnet."}
      </Snackbar>
    </>
  );
};

const state = ({ postStore, groupStore, categoryStore, userStore }) => {
  const { data: userInformation } = userStore.information;
  const { allCategories } = categoryStore;
  const {
    data: allCategoriesInformation,
    states: allCategoriesInformationStates,
  } = allCategories;
  const { data: groupInformation, states: groupInformationStates } =
    groupStore.group;
  const { data: postInformation, states: postInformationStates } =
    postStore.post;
  const { states: editPostStates } = postStore.editPost;

  return {
    userInformation,
    allCategoriesInformation,
    allCategoriesInformationStates,
    groupInformation,
    groupInformationStates,
    postInformation,
    postInformationStates,
    editPostStates,
  };
};

export default connect(state)(Component);
